import sileo from 'sileo';

const ForwardableBoard = new sileo.Model('hqzen', 'forwardable-boards');

const state = {
    forwardableBoards: []
};

const mutations = {
    setForwardableBoards(state, forwardableBoards) {
        state.forwardableBoards = forwardableBoards;
    }
};

const actions = {

    fetchForwardableBoards({ commit }) {
        return ForwardableBoard.objects.filter()
            .then(data => {
                commit('setForwardableBoards', data);
                return data;
            });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
